import { createFileRoute } from '@tanstack/react-router';
import { BoundaryEditorPage } from '@/features/boundaries/BoundaryEditorPage';

export const Route = createFileRoute('/_staff/staff/projects_/$projectId/boundary')({
  validateSearch: (s: Record<string, unknown>): { from?: string } => ({ from: typeof s.from === 'string' ? s.from : undefined }),
  component: BoundaryRoute,
});

function BoundaryRoute() {
  const { projectId } = Route.useParams();
  const { from } = Route.useSearch();
  return <BoundaryEditorPage key={from ?? ''} projectId={projectId} from={from} />;
}
